import { Component, HostListener, inject, signal, effect, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';
import { BrokerQuoteService } from '../../services/brokerQuote.service';
import { BrokerCompanyResponse, BrokerLandingInfo, BrokerResponse, BrokerStateResponse, BrokerUserResponse, Footer, Model, QuoteOwnerResponse, StatusListResponse, UserNameList, UWAdminLandingInfo, UWAdminResponse } from '../../models/QuoteList';
import { PropertyService } from '../../services/property.service';
import { debounceTime, switchMap, filter, map } from 'rxjs/operators';
import { forkJoin, Subject, Subscription, of } from 'rxjs';
import { AccordFormComponent } from '../accord-form/accord-form.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../auth/auth.service';
import { GetUserDetails } from '../../models/sessionStorage.model';
import { StepIdListResponse } from '../../models/RequestQuote';
import { IndicationQuoteStepService } from '../../services/indicationQuoteStep.service';
import { ToastService } from '../../services/toast.service';
import { IndicationStatus, ToastType } from '../../enums/config.enum';
import { SpinnerComponent } from '../utils/spinner/spinner.component';

@Component({
  selector: 'app-quote',
  standalone: true,
  imports: [HeaderComponent,FooterComponent,CommonModule,SpinnerComponent],
  templateUrl: './quote.component.html',
  styleUrl: './quote.component.scss'
})
export class QuoteComponent implements OnDestroy {

  role: number | null = null;
  Id = signal<string |null>(null);
  userId = signal<number | null>(null);
  companyId = signal<string | null>(null);
  branchId = signal<string | null>(null);
  tempQuoteId:number |null = null;
  menuOpen = false;
  router = inject(Router);
  brokerQuoteService = inject(BrokerQuoteService);
  brokerQuoteList = signal<BrokerLandingInfo[]>([]);
  uwAdminQuoteList = signal<UWAdminLandingInfo[]>([]);
  brokerQuoteSummaryInfo!:Footer;
  brokerQuoteSummaryInfoIndication: any = signal<any>({statusSummary: {}});
  displayedPages = signal<number[]>([]);
  currentPageNumber = signal<number>(1);
  currentPageSize = signal<number>(10);
  totalPages = signal<number>(0);
  selectedFilter = signal<number[]>([]);
  selectedBrokerCompany = signal<number[]>([]);
  selectedBrokerUser = signal<number[]>([]);
  selectedState = signal<number[]>([]);
  selectedQuoteOwner = signal<number[]>([]);
  searchQuery = signal('');
  searchSubject = new Subject<string>();
  isSearchInputChange = signal<boolean>(false);
  jumpToPage = signal<number | null>(null);
  totalItems = signal<number | null>(null);
  startItem = signal<number | null>(null);
  endItem = signal<number | null>(null);
  brokerQuoteStatusList = signal<StatusListResponse[]>([]);  
  toastService = inject(ToastService);
  authService = inject(AuthService);
  propertyService = inject(PropertyService);
  indicationQuoteService = inject(IndicationQuoteStepService);
  currentSortField = signal('Date');
  currentSortDirection = signal('Desc');
  currentFilterList: any = [];
  brokerCompanyList = signal<BrokerCompanyResponse[]>([]);
  brokerUserList = signal<BrokerUserResponse[]>([]);
  brokerStateList = signal<BrokerStateResponse[]>([]);
  quoteOwnerList = signal<QuoteOwnerResponse[]>([]);
  storageData = signal<GetUserDetails | null>(null);
  stepIdList = signal<StepIdListResponse[]>([]);
  isLoading = signal(false);
  private searchSubscription: Subscription | undefined;


  constructor(private dialog: MatDialog) {this.setupSearch()}

  ngOnInit(): void {
    const storageData = this.authService.getUserDetailsFromStorage();
    this.storageData.set(storageData);
    this.role = storageData.userRole ? Number(storageData.userRole) : null;
    this.userId.set(storageData?.userDetails?.userId);
    this.branchId.set(storageData?.branchId);
    this.companyId.set(storageData?.companyId);
    this.Id.set(storageData?.Id);

    const storedFilters = sessionStorage.getItem('currentFilterList');
    this.restoreUwSelectionsFromStorage();
     if (storedFilters) {
         this.currentFilterList = JSON.parse(storedFilters);
            if (this.currentFilterList.length > 0) {
              if(this.isUwAdmin()){
                  if (this.hasUwSelections()) {
                    this.refreshAllDropdowns();
                    this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
                    this.fetchStepIdList();
                  } else {
                    this.initFilterData();
                    this.fetchStepIdList();
                  }
              }else{
                  this.fetchPOSUserFilterList();  
                  this.fetchStepIdList();                    
                } 
            }else{
                if(this.isUwAdmin()){
                        this.fetchUWAdminDataList(this.currentPageNumber(), this.currentPageSize());
                      }else{
                        this.fetchPOSUserDataList(this.currentPageNumber(), this.currentPageSize());      
                      }  
                  }
    }else{
       if(this.isUwAdmin()){
                        if (this.hasUwSelections()) {
                          this.refreshAllDropdowns();
                          this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
                          this.fetchStepIdList();
                        } else {
                          this.fetchUWAdminDataList(this.currentPageNumber(), this.currentPageSize());
                        }
                      }else{
                        this.fetchPOSUserDataList(this.currentPageNumber(), this.currentPageSize());      
                      } 
    }
 
      
  }

  applyStoredFilters(): void {
    const toIds = (type: string): number[] =>
      this.currentFilterList
        .filter((f: any) => f.type === type)
        .map((f: any) => {
          const id = Number(f.id);
          if (!Number.isNaN(id) && id > 0) return id;
          switch (type) {
            case 'brokerCompany':
              return this.brokerCompanyList().find((item) => item.companyName === f.name)?.companyId || 0;
            case 'brokerUser':
              return this.brokerUserList().find((item) => item.fullName === f.name)?.userId || 0;
            case 'filter':
              return this.brokerQuoteStatusList().find((item) => item.code === f.name)?.gencodeId || 0;
            case 'state':
              return this.brokerStateList().find((item) => item.stateName === f.name)?.stateId || 0;
            case 'quoteOwner':
              return this.quoteOwnerList().find((item) => item.userName === f.name)?.userId || 0;
            default:
              return 0;
          }
        })
        .filter((id: number) => !Number.isNaN(id) && id > 0);

    this.selectedBrokerCompany.set([...new Set(toIds('brokerCompany'))]);
    this.selectedFilter.set([...new Set(toIds('filter'))]);
    this.selectedBrokerUser.set([...new Set(toIds('brokerUser'))]);
    this.selectedState.set([...new Set(toIds('state'))]);
    this.selectedQuoteOwner.set([...new Set(toIds('quoteOwner'))]);
    this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
  }

 

  fetchQuoteList(currentPageNumber: number, currentPageSize: number){    
    this.isUwAdmin() ? this.fetchUWAdminQuoteList(currentPageNumber, currentPageSize) : 
    this.fetchBrokerQuoteList(currentPageNumber, currentPageSize) // Broker user API call
  }

  fetchBrokerQuoteList(currentPageNumber: number, currentPageSize: number){
    this.brokerQuoteService.fetchAllQuoteList(currentPageNumber, currentPageSize, this.getSortParams()).subscribe({
      next: (response: BrokerResponse) => {
        if(response){
          this.brokerQuoteList.set(response.brokerLandingGrids);
          this.isLoading.set(false)
          this.onHandleResponseDataBind(response);
          
        }
      },
      error: (error) => {
        this.isLoading.set(false);
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  fetchUWAdminQuoteList(currentPageNumber: number, currentPageSize: number){
    this.brokerQuoteService.fetchQuoteListForUWAdmin(currentPageNumber, currentPageSize, this.getUWAdminAddtnlParams()).subscribe({
      next: (response: UWAdminResponse) => {
        if(response){
          this.uwAdminQuoteList.set(response.uwLandingGrid);
          this.isLoading.set(false);
          this.onHandleResponseDataBind(response);
        }
      },
      error: (error) => {
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  fetchUWAdminDataList(currentPageNumber: number, currentPageSize: number) {
    this.isLoading.set(true)
    this.brokerQuoteService.fetchQuoteListForUWAdmin(currentPageNumber, currentPageSize, this.getUWAdminAddtnlParams()).subscribe({
      next: (response: UWAdminResponse) => {
        if(response){
          this.authService.setLoading(false)
          this.scrollToTop()
          this.uwAdminQuoteList.set(response.uwLandingGrid);
          this.onHandleResponseDataBind(response);
          this.initFilterData();
          this.fetchStepIdList(); // stepId List
        }
      },
      error: (error) => {
        this.isLoading.set(false)
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  fetchPOSUserDataList(currentPageNumber: number, currentPageSize: number) {    
    this.isLoading.set(true)
    this.brokerQuoteService.fetchAllQuoteList(currentPageNumber, currentPageSize, this.getSortParams()).subscribe({
      next: (response: BrokerResponse) => {
        if(response){
          this.authService.setLoading(false)
          this.scrollToTop()
          this.brokerQuoteList.set(response.brokerLandingGrids);
          this.onHandleResponseDataBind(response);
          this.fetchPOSUserFilterList();
          this.fetchStepIdList(); // stepId List
          
        }
      },
      error: (error) => {
        this.isLoading.set(false)
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  fetchPOSUserFilterList() {     
    this.isLoading.set(true)   
    forkJoin([
      this.brokerQuoteService.fetchBrokerStatus(this.buildSelectedFilters()),
      this.brokerQuoteService.fetchQuoteOwnerList(String(this.companyId()), String(this.branchId()), this.buildSelectedFilters()),
      this.brokerQuoteService.fetchBrokerState(this.buildSelectedFilters()),
    ]).pipe(
      map(([statusList, quoteOwnerList, stateList]) => {
        return {statusList, quoteOwnerList, stateList};
      })
    ).subscribe({
      next: (response: any) => {
        if(response){
          this.brokerQuoteStatusList.set(response.statusList);
          this.quoteOwnerList.set(response.quoteOwnerList);
          this.brokerStateList.set(response.stateList);
          this.brokerQuoteService.setStatusList(response.statusList); // set the status list for resusability
          //retain filters
           const storedFilters = sessionStorage.getItem('currentFilterList');
           
              if (storedFilters ) {
                this.currentFilterList = JSON.parse(storedFilters); 
                  if (this.currentFilterList.length > 0) {               
                  // Apply stored filter values to signals
                  this.applyStoredFilters();
                  // After applying stored selections, refresh dependent POS dropdowns with combined filters
                  this.refreshPosAllDropdowns();
                }else{
                  this.isLoading.set(false)
                }
              }else{
                this.isLoading.set(false)
              }
              
        }
      },
      error: (error) => {
        this.isLoading.set(false)
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  onSetUserNameList(data: any, isBrokerUser: boolean){
    const extractedData: UserNameList[] = data.map((user: any) => ({
      userId: user.userId,
      fullName: user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.userName,
      userRoleId: isBrokerUser ? user?.userDetails?.userRoleId : user?.userRoleId
    }));
    this.brokerQuoteService.setUsersNameList(extractedData);
  }

  fetchStepIdList() {    
    this.indicationQuoteService.fetchStepIdList().subscribe({
      next: (response: StepIdListResponse[]) => {
        if(response){
          this.stepIdList.set(response);
        }
      },
      error: (error: any) => {
        console.log("error", error);
      }
    })
  }

  // This method listens to input changes and applies debounce
  setupSearch(): void {
    effect(() => {
      const minChars = 3
      this.searchSubscription = this.searchSubject.pipe(
        debounceTime(300), // Wait for 300ms after the last keypress
        filter(query => {
          const queryLength = query.length;
          if(query.trim() && queryLength >= minChars){return true;}
          else{
            this.currentPageNumber.set(1);
            this.jumpToPage.set(null);
            if(this.isSearchInputChange()){
              this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
              this.isSearchInputChange.set(false);
            }
            return false;
          }
        }), // Only proceed if query has enough characters
        switchMap(query => {
          const searchBy = query.trim();
          this.currentPageNumber.set(1);
          this.jumpToPage.set(null);
          this.isSearchInputChange.set(true);
          if(this.isUwAdmin()){
            return this.brokerQuoteService.fetchQuoteListForUWAdmin(this.currentPageNumber(), this.currentPageSize(), this.getUWAdminAddtnlParams());
          }else{
            return this.brokerQuoteService.fetchAllQuoteList(this.currentPageNumber(), this.currentPageSize(), this.getSortParams());
          }
          
        })
      ).subscribe({
        next: (response: any) => {
          if(response){
            this.isUwAdmin() ? this.uwAdminQuoteList.set(response.uwLandingGrid) : this.brokerQuoteList.set(response.brokerLandingGrids);
            this.onHandleResponseDataBind(response);
          }
        },
        error: (error) => {
          console.log("error", error);
        }
      });
    });
  }

  onHandleResponseDataBind(responseData: BrokerResponse | UWAdminResponse){
    const {model, footer} = responseData;
    this.brokerQuoteSummaryInfo = footer;
    this.brokerQuoteSummaryInfoIndication.set({
      indicationStatusSummary: {
        'indication': footer.indicationStatusSummary['Indication - In Progress'],
        'referral': footer.indicationStatusSummary['Indication - Referral In Progress']
      }
    });
    this.currentPageSize.set(model.pageSize);
    this.currentPageNumber.set(model.currentPage);
    this.totalPages.set(model.totalPages);
    this.totalItems.set(model.numOfRecords);
    this.startItem.set((model.currentPage - 1) * model.pageSize + 1);
    const end = model.currentPage * model.pageSize;
    const endRange = end > model.numOfRecords ? model.numOfRecords : end;
    this.endItem.set(endRange);
    this.updateDisplayedPages(model);
  }

  fetchFilterListData(){
     this.isLoading.set(true) 
    forkJoin([
      this.brokerQuoteService.fetchBrokerCompanyList(this.buildSelectedFilters()),
      this.brokerQuoteService.fetchBrokerUserList(this.buildSelectedFilters()),
      this.brokerQuoteService.fetchBrokerState(this.buildSelectedFilters()),
      this.brokerQuoteService.fetchBrokerStatus(this.buildSelectedFilters())
    ]).pipe(
      map(([brokerHouse, brokerUser, brokerState, statusList]) => {
        return {brokerHouse, brokerUser, brokerState, statusList};
      })
    ).subscribe({
      next: (response: any) => {
        if(response){
          this.brokerCompanyList.set(response.brokerHouse);
          this.brokerUserList.set(response.brokerUser);
          this.brokerStateList.set(response.brokerState);
          this.brokerQuoteStatusList.set(response.statusList);
          //retain filters
           const storedFilters = sessionStorage.getItem('currentFilterList');
              if (storedFilters) {
                this.currentFilterList = JSON.parse(storedFilters);
                  if (this.currentFilterList.length > 0) {
                    // Apply stored filter values to signals
                    this.applyStoredFilters();
                  }else{
                    this.isLoading.set(false)
                  }
              }else{
                this.isLoading.set(false)
              }
          this.brokerQuoteService.setStatusList(response.statusList); // set the status list for resusability
        }
      },
      error: (error) => {
        this.isLoading.set(false)
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  onJumpToChange(event: Event): void{
    const input = event.target as HTMLInputElement;
    if (input.value !== '') {
      this.jumpToPage.set(Number(input.value))
    }else{
      this.jumpToPage.set(1); 
    }
  }

  // Method to jump to the specific page
  jumpToSpecificPage() {
    const page = this.jumpToPage();
    if(!this.jumpToPage()){
      return;
    }

    if (page && page >= 1 && page <= this.totalPages()) {
      this.currentPageNumber.set(page);
    } else {
      this.jumpToPage.set(1);
      this.currentPageNumber.set(1);
    }

    this.onPageSeleted(this.currentPageNumber(), true);
  }

  // Validation method to allow only numeric values
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    
    // Check if the input is a number or control keys (backspace, delete, etc.)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery.set(input.value);
    // Emit the new value to the subject
    this.searchSubject.next(input.value);
  }

  onClearSearch() {
    this.searchQuery.set('');
    // Emit the new value to the subject
    this.searchSubject.next('');
  } 

  updateDisplayedPages(modelInfo: Model): void {
    const totalPages = modelInfo.totalPages;

    // Calculate the range of pages to display
    const startPage = Math.max(1, modelInfo.currentPage + 1 - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    let pagesToDisplay = [];
    for (let i = startPage; i <= endPage; i++) {
      pagesToDisplay.push(i);
    }
    this.displayedPages.set(pagesToDisplay);
  }

  getBrokerCompanyName(companyId: string) {
    const getCompanyName = this.brokerCompanyList().filter((company) => String(company.companyId) === companyId);
    getCompanyName.length > 0 ? getCompanyName[0].companyName : '';
  }

  getSortParams(): { [key: string]: string | number | null } {
    const sortParams: { [key: string]: string | number | null } = {branchId: this.branchId(), sort: this.currentSortDirection(), sortColumn: this.currentSortField()};
    if (this.selectedFilter().length) sortParams['status'] = this.selectedFilter().join(',');
    if (this.selectedState().length) sortParams['states'] = this.selectedState().join(',');
    if (this.selectedQuoteOwner().length) sortParams['quoteOwner'] = this.selectedQuoteOwner().join(',');
    if(this.searchQuery() && this.searchQuery().length >= 3){
      sortParams['search'] = this.searchQuery();
    }
    return sortParams;
  }

  getUWAdminAddtnlParams(): { [key: string]: string | number | null }{
    const addnlParams: { [key: string]: string | number | null } = {sort: this.currentSortDirection(), sortColumn: this.currentSortField()};
    if (this.selectedFilter().length) addnlParams['status'] = this.selectedFilter().join(',');
    if (this.selectedState().length) addnlParams['state'] = this.selectedState().join(',');
    if (this.selectedBrokerCompany().length) addnlParams['company'] = this.selectedBrokerCompany().join(',');
    if (this.selectedBrokerUser().length) addnlParams['brokerId'] = this.selectedBrokerUser().join(',');
    if(this.searchQuery() && this.searchQuery().length >= 3){
      addnlParams['isSearch'] = 1;
      addnlParams['search'] = this.searchQuery();
    }else{
      const defaultValue = 0;
      addnlParams['isSearch'] = defaultValue;
      addnlParams['search'] = defaultValue;
    }
    return addnlParams;
  }

  onSort(field: any, isSortIconUpdated=false): void {
    if (this.currentSortField() === field && isSortIconUpdated) {
      // If the same column is clicked, toggle direction
      this.currentSortDirection.set(this.currentSortDirection() === 'Asc' ? 'Desc' : 'Asc');
    } else if(isSortIconUpdated) {
      // If a new column is clicked, set to ascending by default
      this.currentSortField.set(field);
      this.currentSortDirection.set('Asc');
    }
    const isJumpToPageActive = this.jumpToPage() ? true : false;
    this.onPageSeleted(this.currentPageNumber(), isJumpToPageActive);
  }

  onPageSeleted(currentPage: number, isJumpToUserUpdate: boolean = false){
    this.fetchQuoteList(currentPage, this.currentPageSize());
    if (!isJumpToUserUpdate) this.jumpToPage.set(null);
  }

  private getSelectedValue(event: Event): number {
    const select = event.target as HTMLSelectElement;
    const value = Number(select.value);
    return Number.isNaN(value) ? 0 : value;
  }

  private toggleSelection(current: number[], selectedId: number): number[] {
    if (!selectedId) return [];
    if (current.includes(selectedId)) {
      return current.filter((id) => id !== selectedId);
    }
    return [...current, selectedId];
  }

  private updateFilterPills(
    type: 'filter' | 'quoteOwner' | 'brokerCompany' | 'brokerUser' | 'state',
    selectedIds: number[],
    getNameById: (id: number) => string
  ) {
    const withoutType = this.currentFilterList.filter((item: any) => item.type !== type);
    const nextTypeFilters = selectedIds.map((id) => ({ type, id, name: getNameById(id) }));
    this.currentFilterList = [...withoutType, ...nextTypeFilters];
  }

  

  onStatusChange(event: Event){
    const selectedId = this.getSelectedValue(event);
    const selectedIds = this.toggleSelection(this.selectedFilter(), selectedId);
    this.currentPageNumber.set(1);
    this.jumpToPage.set(null);
    this.selectedFilter.set(selectedIds);
    this.updateFilterPills('filter', selectedIds, (id) =>
      this.brokerQuoteStatusList().find((status) => status.gencodeId === id)?.code || ''
    );
    if(selectedIds.length){
      if (this.isUwAdmin()) {
        this.refreshDependentDropdowns('status');
      } else {
        this.refreshPosDependentDropdowns('status');
      }
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
    }else{
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
    }
    this.saveFiltersToSessionStorage();
    this.saveUwSelectionsToStorage();
  }

  onQuoteOwnerChange(event: Event){
    const selectedId = this.getSelectedValue(event);
    const selectedIds = this.toggleSelection(this.selectedQuoteOwner(), selectedId);
    this.currentPageNumber.set(1);
    this.jumpToPage.set(null);
    this.selectedQuoteOwner.set(selectedIds);
    this.updateFilterPills('quoteOwner', selectedIds, (id) =>
      this.quoteOwnerList().find((owner) => owner.userId === id)?.userName || ''
    );
    if(selectedIds.length){
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
      // refresh other POS dropdowns (status, state)
      if (!this.isUwAdmin()) {
        this.refreshPosDependentDropdowns('quoteOwner');
      }
    }else{
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
    }
    this.saveFiltersToSessionStorage();
  }

onBrokerCompanyChange(event: Event) {
  const selectedCompanyId = this.getSelectedValue(event);
  const selectedCompanyIds = this.toggleSelection(this.selectedBrokerCompany(), selectedCompanyId);

  this.currentPageNumber.set(1);
  this.jumpToPage.set(null);
  this.selectedBrokerCompany.set(selectedCompanyIds);
  this.updateFilterPills('brokerCompany', selectedCompanyIds, (id) =>
    this.brokerCompanyList().find((company) => company.companyId === id)?.companyName || ''
  );

  if (selectedCompanyIds.length) {
    // Refresh dependent dropdowns using combined filters
    this.refreshDependentDropdowns('company');
    this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
  } else {
    // Reset to full initial load

    // Also clear saved company/user ids
    sessionStorage.removeItem('selectedCompanyId');
    sessionStorage.removeItem('selectedUserIds');

    this.initFilterData();
    this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
  }

  this.saveFiltersToSessionStorage();
  this.saveUwSelectionsToStorage();
}

initFilterData() {
  const storedIds = this.getCompanyAndUserIdsFromSessionStorage();
  
  if (storedIds && storedIds.companyId !== 0 && storedIds.userIds.length > 0) {
    // If companyId and userIds exist, load filtered dropdowns
    this.brokerQuoteService.fetchBrokerCompanyList(this.buildSelectedFilters()).subscribe(companies => {
      this.brokerCompanyList.set(companies);
 // Delay applying value until after view updates with options
  setTimeout(() => {
    this.selectedBrokerCompany.set([storedIds.companyId]);
  });
      // Load users, states, statuses for saved IDs
      forkJoin([
        this.brokerQuoteService.fetchBrokerUserList({ companyIds: [storedIds.companyId] }),
        this.brokerQuoteService.fetchBrokerStatus({ userIds: storedIds.userIds, companyIds: [storedIds.companyId] }),
        this.brokerQuoteService.fetchBrokerState({ userIds: storedIds.userIds, companyIds: [storedIds.companyId] })
      ]).subscribe(([users, statuses, states]) => {
        this.brokerUserList.set(users);
        
        this.brokerQuoteStatusList.set(statuses);
        this.brokerStateList.set(states);

        // Restore the other filters from session
        // const storedFilters = sessionStorage.getItem('currentFilterList');
        // if (storedFilters) {
        //   this.currentFilterList = JSON.parse(storedFilters);
        // }

        // ✅ STEP 1: Users
this.brokerUserList.set(users);
setTimeout(() => {
  const userFilters = this.getFiltersByType('brokerUser');
  const validIds = userFilters
    .map((filter: any) => Number(filter.id))
    .filter((id: number) => this.brokerUserList().some(u => u.userId === id));
  this.selectedBrokerUser.set(validIds);
});


        // ✅ STEP 2: Status
        this.brokerQuoteStatusList.set(statuses);
        setTimeout(() => {
          const statusIds = this.getFiltersByType('filter')
            .map((filter: any) => Number(filter.id))
            .filter((id: number) => this.brokerQuoteStatusList().some(status => status.gencodeId === id));
          this.selectedFilter.set(statusIds);
        });

        // ✅ STEP 3: State
        this.brokerStateList.set(states);
        setTimeout(() => {
          const stateIds = this.getFiltersByType('state')
            .map((filter: any) => Number(filter.id))
            .filter((id: number) => this.brokerStateList().some(state => state.stateId === id));
          this.selectedState.set(stateIds);
        });


         const storedFilters = sessionStorage.getItem('currentFilterList');
              if (storedFilters) {
                this.currentFilterList = JSON.parse(storedFilters);
                  if (this.currentFilterList.length > 0) {
                    // Apply stored filter values to signals
                    
                    this.applyStoredFilters();
                  }else{
                    this.isLoading.set(false)
                  }
              }else{
                this.isLoading.set(false)
              }
        
        this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
      });
    });
  } else {
    // No saved IDs -> load normal default lists
    this.fetchFilterListData();
  }
}

private getFiltersByType(type: string) {
  return this.currentFilterList.filter((f: any) => f.type.trim() === type.trim());
}


  onBrokerUserChange(event: Event){
    const selectedId = this.getSelectedValue(event);
    const selectedIds = this.toggleSelection(this.selectedBrokerUser(), selectedId);
    this.currentPageNumber.set(1);
    this.jumpToPage.set(null);
    this.selectedBrokerUser.set(selectedIds);
    this.updateFilterPills('brokerUser', selectedIds, (id) =>
      this.brokerUserList().find((user) => user.userId === id)?.fullName || ''
    );
    if(selectedIds.length){
      this.refreshDependentDropdowns('user');
      this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
    }else{
      this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
    }
    this.saveFiltersToSessionStorage();
    this.saveUwSelectionsToStorage();
  }


  onStateChange(event: Event){
    const selectedId = this.getSelectedValue(event);
    const selectedIds = this.toggleSelection(this.selectedState(), selectedId);

    this.currentPageNumber.set(1);
    this.jumpToPage.set(null);
    this.selectedState.set(selectedIds);
    this.updateFilterPills('state', selectedIds, (id) =>
      this.brokerStateList().find((state) => state.stateId === id)?.stateName || ''
    );
    if(selectedIds.length){
      if (this.isUwAdmin()) {
        this.refreshDependentDropdowns('state');
      } else {
        this.refreshPosDependentDropdowns('state');
      }
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
    }else{
      this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
    }
    this.saveFiltersToSessionStorage();
    this.saveUwSelectionsToStorage();
  }

onClearCurrentFilter(type: string, id?: number) {
  const removeExistingFilter = this.currentFilterList.filter((item: any) => {
    if (item.type !== type) return true;
    if (id === undefined) return false;
    return Number(item.id) !== Number(id);
  });

  const remainingIdsByType = (filterType: string) =>
    removeExistingFilter
      .filter((item: any) => item.type === filterType)
      .map((item: any) => Number(item.id))
      .filter((value: number) => !Number.isNaN(value) && value > 0);

  switch (type) {
    case 'filter': // Status filter
      this.selectedFilter.set(remainingIdsByType('filter'));
      break;

    case 'brokerCompany':
      this.selectedBrokerCompany.set(remainingIdsByType('brokerCompany'));
      // ❗ Clear stored IDs
      sessionStorage.removeItem('selectedCompanyId');
      sessionStorage.removeItem('selectedUserIds');

      // Reset Users, States, Statuses to full lists (UW Admin only context)
      forkJoin([
        this.brokerQuoteService.fetchBrokerUserList(this.buildSelectedFilters()),
        this.brokerQuoteService.fetchBrokerState(this.buildSelectedFilters()),
        this.brokerQuoteService.fetchBrokerStatus(this.buildSelectedFilters())
      ]).subscribe(([users, states, statuses]) => {
        this.brokerUserList.set(users);
        this.brokerStateList.set(states);
        this.brokerQuoteStatusList.set(statuses);
      });
      break;

    case 'brokerUser':
      this.selectedBrokerUser.set(remainingIdsByType('brokerUser'));
      // ❗ Clear userIds but keep companyId if needed
      sessionStorage.removeItem('selectedUserIds');

      // Reset States & Statuses (but keep Users list as is)
      forkJoin([
        this.brokerQuoteService.fetchBrokerState(this.buildSelectedFilters()),
        this.brokerQuoteService.fetchBrokerStatus(this.buildSelectedFilters())
      ]).subscribe(([states, statuses]) => {
        this.brokerStateList.set(states);
        this.brokerQuoteStatusList.set(statuses);
      });
      break;

    case 'state':
      this.selectedState.set(remainingIdsByType('state'));
      // Only clear state filter
      break;

    case 'quoteOwner':
      this.selectedQuoteOwner.set(remainingIdsByType('quoteOwner'));
      break;
  }

  this.currentFilterList = removeExistingFilter;
  if (!this.currentFilterList.length) {
    this.onClearAllfilter();
    return;
  }
  this.currentPageNumber.set(1);
  this.jumpToPage.set(null);

  // Map filter type to refresh keys
  let changedKeyUW: 'company' | 'user' | 'status' | 'state' | null = null;
  let changedKeyPOS: 'status' | 'state' | 'quoteOwner' | null = null;
  if (type === 'filter') { changedKeyUW = 'status'; changedKeyPOS = 'status'; }
  if (type === 'brokerCompany') { changedKeyUW = 'company'; }
  if (type === 'brokerUser') { changedKeyUW = 'user'; }
  if (type === 'state') { changedKeyUW = 'state'; changedKeyPOS = 'state'; }
  if (type === 'quoteOwner') { changedKeyPOS = 'quoteOwner'; }

  // Refresh dependent dropdowns appropriately
  if (this.isUwAdmin()) {
    if (changedKeyUW && changedKeyUW !== null) {
      this.refreshDependentDropdowns(changedKeyUW);
    }
  } else {
    if (changedKeyPOS && changedKeyPOS !== null) {
      this.refreshPosDependentDropdowns(changedKeyPOS);
    }
  }

  this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
  this.saveFiltersToSessionStorage();
  this.saveUwSelectionsToStorage();
}



onClearAllfilter() {
  this.currentFilterList = [];
  this.selectedFilter.set([]);
  this.selectedBrokerCompany.set([]);
  this.selectedBrokerUser.set([]);
  this.selectedState.set([]);
  this.selectedQuoteOwner.set([]);
  this.searchQuery.set('');
  this.isSearchInputChange.set(false);
  this.currentPageNumber.set(1);
  this.jumpToPage.set(null);
  this.saveFiltersToSessionStorage();
  this.saveUwSelectionsToStorage();

  // ❗ Clear stored IDs for company & user
  sessionStorage.removeItem('selectedCompanyId');
  sessionStorage.removeItem('selectedUserIds');
  sessionStorage.removeItem('uwSelectedCompanyId');
  sessionStorage.removeItem('uwSelectedUserId');
  sessionStorage.removeItem('uwSelectedStatusId');
  sessionStorage.removeItem('uwSelectedStateId');

  if (this.isUwAdmin()) {
    this.initFilterData();
  } else {
    // For POS, reload dropdowns unfiltered
    this.fetchPOSUserFilterList();
  }

  this.fetchQuoteList(this.currentPageNumber(), this.currentPageSize());
}


  saveFiltersToSessionStorage(): void {
    sessionStorage.setItem('currentFilterList', JSON.stringify(this.currentFilterList));
  }

  saveCompanyAndUserIdsToSessionStorage(companyId: number, userIds: number[]): void {
  sessionStorage.setItem('selectedCompanyId', companyId.toString());
  sessionStorage.setItem('selectedUserIds', JSON.stringify(userIds));
  }

  getCompanyAndUserIdsFromSessionStorage(): { companyId: number, userIds: number[] } | null {
    const companyIdStr = sessionStorage.getItem('selectedCompanyId');
    const userIdsStr = sessionStorage.getItem('selectedUserIds');

    if (companyIdStr && userIdsStr) {
      return {
        companyId: Number(companyIdStr),
        userIds: JSON.parse(userIdsStr)
      };
    }
    return null;
  }

  loadFilteredDropdownsByCompany(companyId: number) {
  // Step 1: Get Broker Users for company
  this.brokerQuoteService.fetchBrokerUserList({ companyIds: [companyId] }).subscribe(userList => {
    this.brokerUserList.set(userList);

    // Step 2: Collect userIds
    const userIds = userList.map(u => u.userId);

    // Save in session storage so filtering persists
    this.saveCompanyAndUserIdsToSessionStorage(companyId, userIds);

    if (userIds.length > 0) {
      // Step 3: Fetch Status & State lists for these userIds
      forkJoin([
        this.brokerQuoteService.fetchBrokerStatus({ userIds, companyIds: [companyId] }),
        this.brokerQuoteService.fetchBrokerState({ userIds, companyIds: [companyId] })
      ]).subscribe(([statusList, stateList]) => {
        this.brokerQuoteStatusList.set(statusList);
        this.brokerStateList.set(stateList);
        this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
      });

    } else {
      // No users → clear dependent dropdowns
      this.brokerQuoteStatusList.set([]);
      this.brokerStateList.set([]);
      this.fetchUWAdminQuoteList(this.currentPageNumber(), this.currentPageSize());
    }
  });
}

  private buildSelectedFilters() {
    const filters: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] } = {};
    if (this.selectedBrokerCompany().length) {
      filters.companyIds = [...this.selectedBrokerCompany()];
    }
    // Include UW Admin broker user or POS quote owner as userIds
    const selectedUserIds: number[] = [];
    selectedUserIds.push(...this.selectedBrokerUser());
    selectedUserIds.push(...this.selectedQuoteOwner());
    if (selectedUserIds.length) {
      filters.userIds = [...new Set(selectedUserIds)];
    }
    if (this.selectedFilter().length) {
      filters.statusIds = [...this.selectedFilter()];
    }
    if (this.selectedState().length) {
      filters.stateIds = [...this.selectedState()];
    }
    const hasAnyFilter =
      !!(filters.companyIds?.length || filters.userIds?.length || filters.statusIds?.length || filters.stateIds?.length);
    const branchId = Number(this.branchId());
    if (!this.isUwAdmin() && hasAnyFilter && !Number.isNaN(branchId) && branchId > 0) {
      filters.branchIds = [branchId];
    }
    return filters;
  }

  private buildFiltersExcluding(exclude: 'company' | 'user' | 'status' | 'state' | 'quoteOwner') {
    const filters: { companyIds?: number[]; userIds?: number[]; statusIds?: number[]; stateIds?: number[]; branchIds?: number[] } = {};
    if (exclude !== 'company' && this.selectedBrokerCompany().length) {
      filters.companyIds = [...this.selectedBrokerCompany()];
    }

    // userIds should be excluded when exclude is 'user' (UW) or 'quoteOwner' (POS)
    if (exclude !== 'user' && exclude !== 'quoteOwner') {
      const selectedUserIds: number[] = [];
      selectedUserIds.push(...this.selectedBrokerUser());
      selectedUserIds.push(...this.selectedQuoteOwner());
      if (selectedUserIds.length) {
        filters.userIds = [...new Set(selectedUserIds)];
      }
    }

    if (exclude !== 'status' && this.selectedFilter().length) {
      filters.statusIds = [...this.selectedFilter()];
    }
    if (exclude !== 'state' && this.selectedState().length) {
      filters.stateIds = [...this.selectedState()];
    }
    const hasAnyFilter =
      !!(filters.companyIds?.length || filters.userIds?.length || filters.statusIds?.length || filters.stateIds?.length);
    const branchId = Number(this.branchId());
    if (!this.isUwAdmin() && hasAnyFilter && !Number.isNaN(branchId) && branchId > 0) {
      filters.branchIds = [branchId];
    }
    return filters;
  }

  private refreshDependentDropdowns(changed: 'company' | 'user' | 'status' | 'state') {
    if (!this.isUwAdmin()) return;
    const requests = {
      companies: (changed !== 'company') ? this.brokerQuoteService.fetchBrokerCompanyList(this.buildFiltersExcluding('company')) : of(null),
      users: (changed !== 'user') ? this.brokerQuoteService.fetchBrokerUserList(this.buildFiltersExcluding('user')) : of(null),
      statuses: (changed !== 'status') ? this.brokerQuoteService.fetchBrokerStatus(this.buildFiltersExcluding('status')) : of(null),
      states: (changed !== 'state') ? this.brokerQuoteService.fetchBrokerState(this.buildFiltersExcluding('state')) : of(null)
    } as const;

    forkJoin(requests).subscribe(({ companies, users, statuses, states }) => {
      if (companies) this.brokerCompanyList.set(companies as any);
      if (users) this.brokerUserList.set(users as any);
      if (statuses) this.brokerQuoteStatusList.set(statuses as any);
      if (states) this.brokerStateList.set(states as any);
    });
  }

  private refreshAllDropdowns() {
    if (!this.isUwAdmin()) return;
    forkJoin({
      companies: this.brokerQuoteService.fetchBrokerCompanyList(this.buildFiltersExcluding('company')),
      users: this.brokerQuoteService.fetchBrokerUserList(this.buildFiltersExcluding('user')),
      statuses: this.brokerQuoteService.fetchBrokerStatus(this.buildFiltersExcluding('status')),
      states: this.brokerQuoteService.fetchBrokerState(this.buildFiltersExcluding('state'))
    }).subscribe(({ companies, users, statuses, states }) => {
      this.brokerCompanyList.set(companies);
      this.brokerUserList.set(users);
      this.brokerQuoteStatusList.set(statuses);
      this.brokerStateList.set(states);
    });
  }

  // POS (Broker) dependent dropdown refresh
  private refreshPosDependentDropdowns(changed: 'status' | 'state' | 'quoteOwner') {
    if (this.isUwAdmin()) return;
    const companyId = String(this.companyId());
    const branchId = String(this.branchId());

    const requests = {
      statuses: (changed !== 'status') ? this.brokerQuoteService.fetchBrokerStatus(this.buildFiltersExcluding('status')) : of(null),
      quoteOwners: (changed !== 'quoteOwner') ? this.brokerQuoteService.fetchQuoteOwnerList(companyId, branchId, this.buildFiltersExcluding('quoteOwner')) : of(null),
      states: (changed !== 'state') ? this.brokerQuoteService.fetchBrokerState(this.buildFiltersExcluding('state')) : of(null)
    } as const;

    forkJoin(requests).subscribe(({ statuses, quoteOwners, states }) => {
      if (statuses) this.brokerQuoteStatusList.set(statuses as any);
      if (quoteOwners) this.quoteOwnerList.set(quoteOwners as any);
      if (states) this.brokerStateList.set(states as any);
    });
  }

  private refreshPosAllDropdowns() {
    if (this.isUwAdmin()) return;
    const companyId = String(this.companyId());
    const branchId = String(this.branchId());
    forkJoin({
      statuses: this.brokerQuoteService.fetchBrokerStatus(this.buildFiltersExcluding('status')),
      quoteOwners: this.brokerQuoteService.fetchQuoteOwnerList(companyId, branchId, this.buildFiltersExcluding('quoteOwner')),
      states: this.brokerQuoteService.fetchBrokerState(this.buildFiltersExcluding('state'))
    }).subscribe(({ statuses, quoteOwners, states }) => {
      this.brokerQuoteStatusList.set(statuses);
      this.quoteOwnerList.set(quoteOwners);
      this.brokerStateList.set(states);
    });
  }

  private hasUwSelections(): boolean {
    return !!(this.selectedBrokerCompany().length || this.selectedBrokerUser().length || this.selectedFilter().length || this.selectedState().length);
  }

  private saveUwSelectionsToStorage() {
    if (!this.isUwAdmin()) return;
    sessionStorage.setItem('uwSelectedCompanyId', this.selectedBrokerCompany().join(','));
    sessionStorage.setItem('uwSelectedUserId', this.selectedBrokerUser().join(','));
    sessionStorage.setItem('uwSelectedStatusId', this.selectedFilter().join(','));
    sessionStorage.setItem('uwSelectedStateId', this.selectedState().join(','));
  }

  private restoreUwSelectionsFromStorage() {
    if (!this.isUwAdmin()) return;
    const parseIds = (value: string | null): number[] =>
      (value || '')
        .split(',')
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id) && id > 0);
    this.selectedBrokerCompany.set(parseIds(sessionStorage.getItem('uwSelectedCompanyId')));
    this.selectedBrokerUser.set(parseIds(sessionStorage.getItem('uwSelectedUserId')));
    this.selectedFilter.set(parseIds(sessionStorage.getItem('uwSelectedStatusId')));
    this.selectedState.set(parseIds(sessionStorage.getItem('uwSelectedStateId')));
  }


  isUwAdmin(): boolean {
    return this.role === 2;
  }

  isSysAdmin(): boolean {
    return this.role === 3;
  }

  isBroker(): boolean {
    return this.role ===1;
  }

  reviewAndEditByBrokerUser(status: string, id: number,isreferral:number) {
    if(isreferral === 1){
      sessionStorage.setItem("isReview", JSON.stringify(true));
    }else{
      sessionStorage.setItem("isReview", JSON.stringify(false));
    }
    this.onSetStatusId(status);
    this.router.navigate(['/request-quote', id]);
  }

  reviewAndEditByUWAdmin(status: string, id: number, isReadOnlyMode: boolean = true) {
    sessionStorage.setItem("isReview", JSON.stringify(isReadOnlyMode));
    this.onSetStatusId(status);
    this.router.navigate(['/request-quote', id]);
  }

  private getStepCodeFromGencode(stepValue: number | string | null | undefined): string | null {
    if (stepValue === null || stepValue === undefined || stepValue === '') {
      return null;
    }

    const matchedStep = this.stepIdList().find(
      (stepInfo: StepIdListResponse) => String(stepInfo.gencodeId) === String(stepValue)
    );

    return matchedStep?.code || String(stepValue);
  }

  onViewIndicationQuoteDetails(type: string, step: number, id:number,status:string,isReferral:number, irStatus: string, uwAdminStep?: number | string | null, isUWAdminAmended?: number | string | null){
    this.setIndicationQuoteTypeDetails(type, id) // set indicationId / quoteId
    const getStepIdInfo = this.stepIdList().filter((stepInfo: StepIdListResponse) => stepInfo.gencodeId === step);
    const uwAdminStepCode = this.getStepCodeFromGencode(uwAdminStep);
    const isUwAdminAmended = Number(isUWAdminAmended ?? 0) === 1;
    const matchedQuoteStatus = this.brokerQuoteList().find(
      (quote) => quote.status === status
    )?.status;
    
    sessionStorage.setItem("isreferral",String(isReferral));
    sessionStorage.setItem("inceptionStatus",irStatus)  
    const status1 = status;
          sessionStorage.setItem("statusRagCall", status);

          const validStatuses = [
            "Indication - Referral Approved",
            "Indication - Referral Declined",
            "Quote - Referral Approved",
            "Quote - Referral Declined",
            "Indication - Referral Submitted",
            "Quote - Referral Submitted",
            "Bind - Referral Submitted"
          ];

          if (validStatuses.includes(status1)) {
            sessionStorage.setItem("statusAvailable", "true");
          } else {
            sessionStorage.setItem("statusAvailable", "false");
            sessionStorage.setItem("RagCall","true")
          }   
    
    if (matchedQuoteStatus === "Indication - Referral Approved"){
      sessionStorage.setItem("AmendDisable","true")
    }else{
      sessionStorage.setItem("AmendDisable","false")
    }    

    if (matchedQuoteStatus === "Indication - Referral Declined"){
      sessionStorage.setItem("requestQuoteDisable","true")
    }else{
      sessionStorage.setItem("requestQuoteDisable","false")
    }

    if (matchedQuoteStatus === "Quote - Referral Declined"){
      sessionStorage.setItem("QuoteReferredDeclined","true")
    }else{
      sessionStorage.setItem("QuoteReferredDeclined","false")
    }   
    

    if(!this.isUwAdmin() && isReferral === 1){ // Broker user trying to select isReferral indication/quote           
          sessionStorage.setItem('currentStepId', "0");
          sessionStorage.setItem("copeInfosave","true");
          sessionStorage.setItem("PolicyInfoSave","true");
          sessionStorage.setItem("isreferral","1")
    }
    
      if(!this.isUwAdmin() && isReferral === 1 && irStatus === "IDR"){ // Broker user trying to select inception date referral isReferral indication/quote           
          sessionStorage.setItem('currentStepId', "0");
          sessionStorage.setItem("copeInfosave","true");
          sessionStorage.setItem("PolicyInfoSave","true");
          sessionStorage.setItem("isreferral","1");
          sessionStorage.setItem("inceptionStatus",irStatus)          
        }

         if(!this.isUwAdmin() && irStatus === "IDRA"){ // Broker user trying to select inception date referral isReferral indication/quote 
         this.brokerQuoteService.setCurrentStepId("4d");       
          sessionStorage.setItem("inceptionStatus",irStatus);
        }

    if(getStepIdInfo.length > 0 && getStepIdInfo[0].code && !this.isUwAdmin() && isReferral !== 1 && irStatus !== "IDRA"){ // Allowing POS User to navigate to last saved accordion/step      
      this.brokerQuoteService.setCurrentStepId(getStepIdInfo[0].code); // setting currentStepId to navigate

    }else{ // Allowing UW Admin to navigate to saved amended step or Clearance by default   
      if(this.isUwAdmin()){
        if (isUwAdminAmended && uwAdminStepCode) {
          this.brokerQuoteService.setCurrentStepId(uwAdminStepCode);
        } else {
          sessionStorage.setItem('currentStepId', "0");
        }
        sessionStorage.setItem("copeInfosave","true");
        sessionStorage.setItem("PolicyInfoSave","true");   
        sessionStorage.setItem("inceptionStatus",irStatus) 
      }    

    } 
    this.isUwAdmin() ? this.reviewAndEditByUWAdmin(status, id, !isUwAdminAmended) : this.reviewAndEditByBrokerUser(status, id,isReferral);
  }

  onPolicySelected(status: string, policyId:number) {
    this.indicationQuoteService.setPolicyId(policyId); // set PolicyId
    this.onSetStatusId(status);
    sessionStorage.setItem("isReview", JSON.stringify(true)); // for Policy by default fields are readonly
    this.brokerQuoteService.setCurrentStepId("5"); // move to the step 5 by default
    sessionStorage.setItem("isMTA", JSON.stringify(true)); 
    sessionStorage.setItem('isPolicyType', JSON.stringify(true));
    this.router.navigate(['/request-quote', policyId]);
  }

  onIndicationOrQuoteSelected(type: string, step: number, status: string, userLock: number, id:number, isReferral: number, irStatus: string, uwAdminStep?: number | string | null, isUWAdminAmended?: number | string | null) {
    if(userLock === 1){
      // Indication / Quote is locked display warning message
      const msg = type === "Indication" ? "This indication is currently being reviewed by another user" :
      "This quote is currently being reviewed by another user"
      this.toastService.addNotification({message: msg, type: ToastType.Info}); // notification
    }else{
      // if(!this.isUwAdmin() && isReferral === 1){ // Broker user trying to select isReferral indication/quote 
      //   const msg = type === "Indication" ? "Your referred indication is submitted and it will be available once after Admin's review" :
      //   "Your referred quote is submitted and it will be available once after Admin's review"
      //   this.toastService.addNotification({message: msg, type: ToastType.Info}); // notification
      //   return;
      // }
      this.onViewIndicationQuoteDetails(type, step, id,status,isReferral, irStatus, uwAdminStep, isUWAdminAmended);
    }
  }

  QuoteDetails(type: string, step: number, status: string, userLock: number, id:number, isReferral: number, irStatus: string, uwAdminStep?: number | string | null, isUWAdminAmended?: number | string | null){
    this.indicationQuoteService.removeIndicationQuoteStorageData(() => {
      if (type === "Policy") {
        this.onPolicySelected(status, id);
      } else {
        this.onIndicationOrQuoteSelected(type, step, status, userLock, id, isReferral, irStatus, uwAdminStep, isUWAdminAmended);
      }
    });
  }

  setIndicationQuoteTypeDetails(type: string, id:number) {
    if(type === "Indication"){
      sessionStorage.setItem('quoteType', "indication");
      sessionStorage.setItem("indicationId", String(id));
      sessionStorage.setItem('versionNo', '1');
      sessionStorage.removeItem('quoteId');
    }else{
      // set quote details
      sessionStorage.setItem('quoteType', "quote");
      sessionStorage.setItem('quoteId', String(id));
      sessionStorage.setItem('versionNo', '1');
      sessionStorage.removeItem('indicationId');
    }
  }
  
  // requestQuote() {
  //   this.router.navigate(['/request-quote'])
  // }

  openMenu() {
    this.menuOpen = true;
  }
  
  closeMenu() {
    this.menuOpen = false;
  }
 
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  AccordForm(){
    const dialogRef = this.dialog.open(AccordFormComponent);

    dialogRef.afterClosed().subscribe((result: string) => {
      if (result === 'exit') {
        this.router.navigate(['/request-quote']);
      }
    });
  }  

  onSetStatusId(statusName: string) {
    const getInprogressStatusList = this.brokerQuoteStatusList().filter((status) => status.code === statusName);
    
    if(getInprogressStatusList.length > 0){
      this.brokerQuoteService.setStatusId(getInprogressStatusList[0]?.gencodeId); // Indication Inprogess gencodeId
    }
  }

  requestQuote() {
    this.propertyService.startNewQuote().subscribe({
      next: (response) => {
        this.indicationQuoteService.removeIndicationQuoteStorageData(() => {
          this.onSetStatusId(IndicationStatus.STATUS_INPROGRESS);
          sessionStorage.setItem('tempQuoteId', String(response.tempId));
          sessionStorage.setItem('tempQuoteNumber', String(response.tempNumber));
          sessionStorage.setItem('createdUserId', String(response.createdUserId));
          sessionStorage.setItem('quoteType', 'indication');
          sessionStorage.setItem('currentStepId', '0');
          sessionStorage.setItem('isReview', JSON.stringify(false));
          sessionStorage.removeItem('copeInfoSave');
          this.router.navigate(['/request-quote']);
        }, { includeTemp: false });
      },
      error: (err) => {
        console.error('Error starting quote', err);
      }
    });
  }

 private isScrolling = false;
  scrollToTop(): void {
    if (this.isScrolling) {
      return; // Prevent multiple simultaneous scrolls
    }
    this.isScrolling = true;
    const scrollDuration = 500; // milliseconds
    const start = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
const startTime = performance.now();
    const easeInOutQuad = (t: number): number => {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };
    const smoothScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / scrollDuration, 1);
      const ease = easeInOutQuad(progress);
      const scrollTo = start * (1 - ease);
      window.scrollTo(0, scrollTo);
      if (progress < 1) {
        window.requestAnimationFrame(smoothScroll);
      } else {
        this.isScrolling = false; // allow normal scrolling after animation
      }
    };
     window.requestAnimationFrame(smoothScroll);
  }    

  
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('#au_header_user_menu_toggle')) {
      this.menuOpen = false;
    }
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();  // Clean up subscription
    }
  }
}
